import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Subcategory from 'modules/budget/components/category/category-table/subcategory';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';

@withNamespaces()
@observer
class Subcategories extends Component {
    render() {
        const { categories, hidden } = this.props;

        return (
            <Fragment>
                {categories.length > 0 ? (
                    categories.map((category) => <Subcategory key={category.id} category={category} hidden={hidden} />)
                ) : (
                    <tr>
                        <td colSpan={2} className="p-l-50 text-muted">
                            {hidden ? 'No subcategories hidden' : 'No subcategories, add one'}
                        </td>
                    </tr>
                )}
                <tr>
                    <td colSpan={2} className="p-1" />
                </tr>
            </Fragment>
        );
    }
}

Subcategories.propTypes = {
    /** Array of subcategories */
    categories: PropTypes.any.isRequired,

    /** Whether this component is displaying hidden categories */
    hidden: PropTypes.bool,
};

export default Subcategories;


// WEBPACK FOOTER //
// ./src/modules/budget/components/category/category-table/subcategories.js